export const bim = {
  addBim: "BIM を追加",
  progressHelp:
    "ファイルを表示するには処理する必要があります。このプロセスには数分かかる場合があります。",
};
